import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=2889a13d&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=ts"
export * from "./UserLogin.vue?vue&type=script&lang=ts"
import style0 from "./UserLogin.vue?vue&type=style&index=0&id=2889a13d&prod&lang=css"
import style1 from "./UserLogin.vue?vue&type=style&index=1&id=2889a13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889a13d",
  null
  
)

export default component.exports